"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinksContextProvider = exports.LinksContext = exports.defaultLinks = void 0;

var _react = require("react");

var defaultLinks = {
  home: {
    url: 'https://storybook.js.org/'
  },
  whyStorybook: {
    url: 'https://storybook.js.org/docs/react/get-started/why-storybook'
  },
  componentDriven: {
    url: 'https://componentdriven.org'
  },
  guides: {
    url: 'https://storybook.js.org/docs'
  },
  tutorials: {
    url: 'https://storybook.js.org/tutorials'
  },
  changelog: {
    url: 'https://storybook.js.org/releases'
  },
  telemetry: {
    url: 'https://storybook.js.org/telemetry'
  },
  showcase: {
    url: 'https://storybook.js.org/showcase'
  },
  projects: {
    url: 'https://storybook.js.org/showcase/projects'
  },
  componentGlossary: {
    url: 'https://storybook.js.org/showcase/glossary'
  },
  integrations: {
    url: 'https://storybook.js.org/integrations'
  },
  getInvolved: {
    url: 'https://storybook.js.org/community'
  },
  blog: {
    url: 'https://storybook.js.org/blog'
  },
  hiring: {
    url: 'https://www.chromatic.com/company/jobs'
  },
  enterprise: {
    url: 'https://www.chromatic.com/enterprise?utm_source=storybook_website&utm_medium=global_nav&utm_campaign=storybook'
  },
  chromatic: {
    url: 'https://www.chromatic.com/storybook?utm_source=storybook_website&utm_medium=global_nav&utm_campaign=storybook'
  }
};
exports.defaultLinks = defaultLinks;
var LinksContext = /*#__PURE__*/(0, _react.createContext)(defaultLinks);
exports.LinksContext = LinksContext;
var LinksContextProvider = LinksContext.Provider;
exports.LinksContextProvider = LinksContextProvider;